import { Hint } from '@/components/ui/Hint';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DOCUMENTS_PROVIDED_TO_IC_RECEIPTS_NAME =
  'documents_provided_to_ic_receipts';

export const DOCUMENTS_PROVIDED_TO_IC_INVOICES_NAME =
  'documents_provided_to_ic_invoices';

export const DOCUMENTS_PROVIDED_TO_IC_OTHER_DOCUMENTS_NAME =
  'documents_provided_to_ic_other_documents';

export const DOCUMENTS_DAMAGE_AOB_LIST_NAME = 'documents_damage_aob_list';

export const DOCUMENTS_DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME =
  'documents_damage_rights_authorizations_list';

export const DOCUMENTS_DAMAGE_RIGHTS_POA_LIST_NAME =
  'documents_damage_rights_poa_list';

const AddDocuments = ({
  name,
  title,
  attachmentTypeId,
}: {
  name: string;
  title?: string;
  attachmentTypeId: (typeof ATTACHMENT_TYPES)[keyof typeof ATTACHMENT_TYPES];
}) => {
  const { i18n } = useLingui();

  const { getFieldState, formState } = useFormContext();

  const fieldState = getFieldState(name, formState);

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać dokumenty?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
    ],
  };

  return (
    <div className="flex flex-col gap-3" id={name}>
      <Uploader
        title={title ?? i18n.t('Dodaj dokumenty')}
        instructionProps={instructionProps}
        inputFieldName={name}
        required
        attachmentTypeId={attachmentTypeId}
      />
      {fieldState.error && (
        <div id={`error-${name}`} className="w-full">
          <Hint color="red">
            {i18n.t('Dodaj plik, aby zakończyć formularz')}
          </Hint>
        </div>
      )}
    </div>
  );
};

export default AddDocuments;
